export enum PlayerCardActionTypes {
  ADD_RG_EXCLUSION = '@playercard/ADD_RG_EXCLUSION',
  GET_COUNTRIES_LIST = '@playercard/GET_COUNTRIES_LIST',
  GET_PLAYER = '@playercard/GET_PLAYER',
  GET_PLAYERS = '@playercard/GET_PLAYERS',
  GET_PLAYER_BALANCE = '@playercard/GET_PLAYER_BALANCE',
  GET_RG_EXCLUSION = '@playercard/GET_RG_EXCLUSION',
  UPDATE_PLAYER = '@playercard/UPDATE_PLAYER',
  UPDATE_ACCOUNT_STATUS = '@playercard/UPDATE_ACCOUNT_STATUS',
  UPDATE_KYC_STATUS = '@playercard/UPDATE_KYC_STATUS',
  SET_PLAYER_BALANCE = '@playercard/SET_PLAYER_BALANCE',
}
